export default {
      id: "download-usage",
      viewBox: "0 0 330 330",
      url: __webpack_public_path__ + "img/icons.svg?fe1823f2d070fe6b8364c4176dd9a880#download",
      toString: function () {
        return this.url;
      }
    }